import React from "react";
import { RefinementList, useRefinementList } from "react-instantsearch";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";
import styled from "styled-components";

export default function BrandFilter() {
  const { items, canRefine } = useRefinementList({
    attribute: "brand",
  });
  const hasSelectedItems = items.some(({ isRefined }) => isRefined);

  return (
    <FilterSection label="Brand" canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      <BrandRefinementList
        attribute="brand"
        searchable
        showMore
        searchablePlaceholder="Search brands..."
        showMoreLimit={50}
      />
    </FilterSection>
  );
}

const BrandRefinementList = styled(RefinementList)`
  .ais-SearchBox-input {
    width: 100%;
    padding: 2px 6px;
    outline-offset: 1px;
    outline-color: #ccc;
    border: 1px solid #ccc;
    border-radius: 3px;
  }
  .ais-SearchBox-reset {
    width: 25px;
    height: 25px;
    margin-left: -25px;
    background: transparent;
    border: none;
    margin-top: 1px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &[hidden] {
      display: none;
    }
    .ais-SearchBox-resetIcon {
      stroke: #999;
      fill: #999;
      width: 9px;
      height: 9px;
    }
  }
  .ais-SearchBox-submit {
    display: none;
  }
  .ais-RefinementList-list {
    padding: 0 2px;
    list-style: none;
  }
  .ais-RefinementList-label {
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
  }
  .ais-RefinementList-labelText {
    flex: 1;
  }
  .ais-RefinementList-count {
    font-size: 0.9em;
    color: #777;
  }
  .ais-RefinementList-showMore {
    background: transparent;
    border: none;
    text-decoration: underline;
    padding: 2px 0;
    cursor: pointer;
    &.ais-RefinementList-showMore--disabled {
      display: none;
    }
  }
`;
